var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187.576,
    height: 84.876,
    viewBox: "0 0 187.576 84.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534",
    transform: "translate(6362.854 -1253.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    transform: "translate(-6362.555 1254.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M-6187.483,1321.979a21.4,21.4,0,0,1-16.661,7.794,21.416,21.416,0,0,1-10.327-2.631c-20.266-11.2-11.888-49.885,2.143-62.746a1.828,1.828,0,0,0,.683.584c-13.348,12.082-21.824,52.126-.2,60.505a23.442,23.442,0,0,0,7.989,1.656c16.661,0,23.189-23.773,22.02-38.291-.681-8.964-4.092-22.994-14.614-25.04a9.875,9.875,0,0,0-2.338-.2c-9.354,0-14.323,10.912-16.661,18.707-1.268,4.19-1.852,8.574-2.825,12.958-.487,2.339-1.364,4.287-2.047,4.287-.486,0-.778-.877-.876-3.118-.293-8.379,3.6-19,8.281-25.819,3.215-4.677,8.574-8.477,14.225-8.477,12.667,0,17.344,16.661,18.415,26.7C-6179.007,1299.862-6180.273,1313.016-6187.483,1321.979Z",
    transform: "translate(6226.554 -1262.156)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M-6072.913,1364.061a14.627,14.627,0,0,1-8.965,3.6c-3.994-.487-5.456-4.677-7.989-7.307a1.843,1.843,0,0,0-1.461-.78c-2.144,0-3.215,6.236-3.7,7.892-.486,2.046-1.169,7.21-1.851,11.01-.1.682-.683,2.825-1.267,2.825-.293,0-.585-.487-.682-2.143-.292-4.969-1.463-17.733-.487-20.851.2-.682.487-1.072,1.169-1.072h.39a1.115,1.115,0,0,1,.682.292,1.45,1.45,0,0,1,.391.877c.1.488,0,3.7,0,4.58.583-2.143,2.144-6.431,4.968-6.431,3.9,0,6.431,9.938,10.036,9.938a2.7,2.7,0,0,0,.876.1c2.533,0,5.554-1.851,7.5-3.118Z",
    transform: "translate(6146.963 -1321.386)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M-6031.622,1365.513a12.728,12.728,0,0,1,2.533-3.215c.876-.877,3.116-2.338,4.774-2.338a1.782,1.782,0,0,1,1.753,1.072c.683,1.364-3.6,2.533-4.773,3.313a8.385,8.385,0,0,0-2.339,2.241c-.584.682-2.727,5.261-.877,5.261,1.462,0,4.578-3.6,6.14-5.456q.437-1.462,1.169-1.461c.583,0,.974,1.461,1.169,4.774v3.7a36.475,36.475,0,0,1,8.865-7.99l.39.682a39.653,39.653,0,0,0-8.67,7.892c-.2.2-.391.488-.585.682,0,6.041-.293,26.6-2.924,31.861-.683.974-1.267,1.364-1.754,1.364-3.117,0-4.189-14.323-2.729-20.168a48.815,48.815,0,0,1,1.56-4.969A31.966,31.966,0,0,1-6025,1377.4c0-3.313.1-5.748.2-7.7,0-.585.1-1.17.1-1.656-1.656,2.143-4.189,4.969-5.944,5.164a1.709,1.709,0,0,1-1.654-.975C-6033.376,1370.481-6032.5,1367.169-6031.622,1365.513Zm4.676,38.875a.523.523,0,0,0,.391.292c.974,0,1.169-7.6,1.169-7.6.292-5.943.39-11.984.39-17.927a30.957,30.957,0,0,0-3.409,8.769A33.827,33.827,0,0,0-6026.946,1404.388Z",
    transform: "translate(6104.988 -1323.52)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M-5983.193,1374.159c-4.287,0-.2-13.154,6.04-13.154a2.689,2.689,0,0,1,.877.1,2.356,2.356,0,0,1,1.56.877.711.711,0,0,1-.2.877,13.06,13.06,0,0,1-2.63,1.266,11.715,11.715,0,0,0-2.046,1.169,9.952,9.952,0,0,0-2.339,2.241c-.779.974-1.852,3.215-1.462,4.774a.733.733,0,0,0,.683.487,2.528,2.528,0,0,0,.974-.389l1.169-.877a33.214,33.214,0,0,0,4-4.19.953.953,0,0,1,.976-.877c.778,0,1.265.585,1.559,1.56.584,3.117.779,7.6,4.969,7.99,5.554,0,9.841-5.359,12.568-9.646l.682.39c-3.021,4.871-7.112,10.425-13.25,11.107-4.677,0-6.626-3.41-7.5-7.307a7.712,7.712,0,0,1-.194-1.365v-.292c-1.656,2.144-4.189,5.067-6.139,5.262Z",
    transform: "translate(6074.974 -1324.176)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M-5876.561,1366.128c-1.656,3.995-4.871,9.159-9.743,9.159-3.409-.292-5.749-3.215-7.21-6.041-1.363-2.728-3.409-7.6-6.04-7.6-.877,0-1.852.585-2.923,1.949-.585.779-6.918,10.912-9.256,10.912-.779,0-1.072-1.169-.488-4.385.1-.682.293-1.364.391-2.046a10.881,10.881,0,0,1,1.169-3.7,1.348,1.348,0,0,1,1.071-.584,1.307,1.307,0,0,1,1.364,1.461,20.127,20.127,0,0,1-1.169,3.605c-.2.487-1.169,2.825-.78,2.825.2,0,.78-.682,2.047-2.728,1.948-2.826,5.262-9.256,9.548-9.256a4.225,4.225,0,0,1,1.852.389c5.456,2.339,4.773,12.277,10.522,13.738,4.482,0,7.308-4.384,9.063-7.989Z",
    transform: "translate(6029.528 -1323.355)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M-5813.626,1342.557c-.2,3.313-3.7,13.64,1.657,13.64a5.7,5.7,0,0,0,1.267-.195c3.9-.974,7.4-4.677,10.814-8.379l.585.389c-3.411,3.8-7.21,8.087-11.3,9.549a8.321,8.321,0,0,1-2.436.39c-6.431,0-5.066-11.984-3.312-15.979.486-1.266.974-1.851,1.559-1.754C-5813.821,1340.609-5813.528,1341.291-5813.626,1342.557Zm-.2-11.887c.878.1,1.365,1.559,1.267,3.215s-.876,3.021-1.655,3.021c-.78-.1-1.462-1.559-1.364-3.215C-5815.282,1331.937-5814.6,1330.671-5813.821,1330.671Z",
    transform: "translate(5970.101 -1305.143)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M-5765.445,1361.625a.816.816,0,0,1-.779-.584c-.293-.974-.585-1.267-.877-1.267-.585,0-1.07,1.364-1.461,2.241-1.267,2.825-1.462,6.625,1.169,8.866a5.249,5.249,0,0,0,3.313,1.267c3.9,0,7.5-4.774,8.964-7.99q.146-.293.293-.292c.194,0,.39.292.292.682-1.949,3.994-5.457,9.061-10.036,9.061a7.326,7.326,0,0,1-3.9-1.266c-4.385-3.216-5.262-12.764.1-15.492a2.99,2.99,0,0,1,1.266-.292,3.126,3.126,0,0,1,2.924,4.385A1.523,1.523,0,0,1-5765.445,1361.625Z",
    transform: "translate(5941.405 -1321.386)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "by",
    transform: "translate(111.588 79.722)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "by")), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(143.472 66.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M-5829,1441.708l-4.141,6.7-4.143-6.7h-4.192v15.963h4.22v-8.8l4.115,6.266,4.113-6.266v8.8h4.22v-15.963Z",
    transform: "translate(5841.478 -1441.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M-5785.364,1447.492c-2.366-.687-3.4-.926-3.4-1.82,0-.605.6-1.086,1.868-1.086a6.212,6.212,0,0,1,3.8,1.411l1.905-3.08a9.736,9.736,0,0,0-5.94-1.934c-3.659,0-5.988,2.169-5.988,5.093,0,2.836,2.24,4.026,4.379,4.647,2.254.655,3.706.857,3.706,1.906,0,.674-.64,1.254-1.871,1.254a7.832,7.832,0,0,1-4.749-2l-2.069,3.154a10.176,10.176,0,0,0,6.795,2.445c3.7,0,6.214-2.115,6.214-5.33C-5780.716,1449.259-5783.049,1448.164-5785.364,1447.492Z",
    transform: "translate(5811.518 -1440.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(32.196 0.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M-5750.84,1453.977v-12.27h-4.226v15.963h11.609v-3.693Z",
    transform: "translate(5755.065 -1441.708)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.02324af3ce37498d2d678001179aedd7.svg";
export { ForwardRef as ReactComponent };